<mat-card>

  <mat-card-content>

    <ct-form [configuration]="configuration"></ct-form>

    <mat-card-actions fxLayout="row wrap" fxLayoutAlign="space-between center">

      <ct-button [configuration]="cancelButton"></ct-button>

      <app-lead-create-workorder *ngIf="masterDetail && (leadStatusComplete || bypassLeadStatus)"></app-lead-create-workorder>

      <ct-button [configuration]="submitButton"></ct-button>

    </mat-card-actions>

  </mat-card-content>

</mat-card>

<app-lead-information *ngIf="masterDetail" [leadOid]="leadOid"></app-lead-information>
